/** PermissionChangedContent — renders `permission_changed` entries (a SpiceDB relation write). */
import React from 'react';
import { useTranslation } from 'localization';
import { TimelineEvent } from 'types/timeline';

interface Props {
  event: TimelineEvent;
}

const PermissionChangedContent: React.FC<Props> = ({ event }) => {
  const { t } = useTranslation();
  const payload = (event.payload ?? {}) as { relation?: string; subjectType?: string };

  return (
    <div className="timeline-event-content">
      <span className="timeline-event-content__text">
        {t('timeline.eventContent.permissionChanged', {
          relation: payload.relation ?? '',
          subjectType: payload.subjectType ?? '',
        })}
      </span>
    </div>
  );
};

export default PermissionChangedContent;
